export default "__VITE_ASSET__KpczvgSZ__"